export interface PointsOfSaleProductModel {
  id: string;
  pos_ids: { pos_id: string; type: ProductPointOfSaleModel[] }[] | null;
  shop_ids: string[] | null;
}

export enum ProductPointOfSaleModel {
  Product = 0,
  Addon = 1,
}
